import React from "react";
import { Box, useMediaQuery, useTheme } from "@mui/material";
import { Modal } from "./components/Modal";

interface DocumentViewerProps {
  openModal: boolean;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedDocument: any | null;
  documentUrl: string | null;
}

const isImage = (fileName: string | undefined): boolean => {
  if (!fileName) return false;
  // Check if filename ends with common image extensions
  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];
  return imageExtensions.some((ext) => fileName.toLowerCase().endsWith(ext));
};

const DocumentViewer: React.FC<DocumentViewerProps> = ({
  openModal,
  setOpenModal,
  selectedDocument,
  documentUrl,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <Modal
      fullScreen={true}
      headerCloseButton={true}
      actions={false}
      open={openModal}
      setOpen={setOpenModal}
      title={selectedDocument?.fileName || ""}
      size="xl"
      onClose={() => setOpenModal(false)}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{
          width: "100%",
          height: "87vh",
          overflow: "hidden",
        }}
      >
        {documentUrl &&
          (isImage(selectedDocument?.fileName) ? (
            <img
              src={documentUrl}
              alt={selectedDocument?.fileName || "Document preview"}
              style={{
                maxWidth: "90%",
                maxHeight: "75vh",
              }}
            />
          ) : (
            <iframe
              src={documentUrl}
              title={selectedDocument?.fileName}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
                display: "block",
              }}
            />
          ))}
      </Box>
    </Modal>
  );
};

export default DocumentViewer;
